import React from 'react';
import PageContainer from 'components/common/PageContainer';
import UnsubscribedContent from 'components/common/UnsubscribedContent';
import DashboardItem from 'components/common/DashboardItem';
import SectionHeader from 'components/text/SectionHeader';
import EmptyState from 'components/common/EmptyState';
import Title from 'components/text/Title';
import styled from 'styled-components';

const ContentContainer = styled.div`
  align-items: center;
  justify-content: center;
  width: 500px;
  max-width: 100%;
  margin: auto;
  margin-top: 55px;
`;

const EmptyContainer = styled.div`
  height: 260px;
`;

const MultiOrgItemContainer = styled.div`
  margin: ${p => p.margin}px;
  padding: ${p => p.padding}px;
`;

const EmptyDashboards = () => (
  <EmptyContainer>
    <EmptyState animationHeight={180} title="No dashboard subscriptions yet..." />
  </EmptyContainer>
);

const NoOrganizationExists = () => (
  <EmptyContainer>
    <EmptyState animationHeight={180} title="No organization yet..." />
  </EmptyContainer>
);

class MultiOrganizationList extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        {this.props.organizations.map(organization => (
          <MultiOrgItemContainer key={organization._id}>
            <Title>
              {organization.title} ({organization.dashboards.length || 0})
            </Title>
            {!organization || !organization.subscribed ? <UnsubscribedContent /> : null}
            {organization && organization.subscribed && (!organization.dashboards || organization.dashboards.length === 0) ? <EmptyDashboards /> : null}
            {organization
              && organization.subscribed
              && organization.dashboards
              && organization.dashboards.length > 0
              && organization.dashboards.map(dashboard => (
                <DashboardItem key={dashboard._id} dashboard={dashboard} organization={organization} />
              ))}
          </MultiOrgItemContainer>
        ))}
      </React.Fragment>
    );
  }
}

class SingleOrganizationList extends React.PureComponent {
  render() {
    const { organization } = this.props;
    return (
      <React.Fragment>
        <MultiOrgItemContainer>
          {!organization || !organization.subscribed ? <UnsubscribedContent /> : null}
            {organization && organization.subscribed && (!organization.dashboards || organization.dashboards.length === 0) ? <EmptyDashboards /> : null}
            {organization
            && organization.subscribed
            && organization.dashboards
            && organization.dashboards.length > 0
            && organization.dashboards.map(dashboard => (
              <DashboardItem key={dashboard._id} dashboard={dashboard} organization={organization} />
            ))}
        </MultiOrgItemContainer>
      </React.Fragment>
    );
  }
}

class AppSubscriptions extends React.PureComponent {
  render() {
    const { organizations } = this.props.currentUser;
    return (
      <PageContainer flex="center">
        <React.Fragment>
          <ContentContainer>
            <SectionHeader>Dashboards</SectionHeader>
            {!organizations || organizations.length === 0 ? <NoOrganizationExists /> : null}
            {organizations && organizations.length === 1 ? (
              <SingleOrganizationList organization={organizations[0]} />
            ) : null}
            {organizations && organizations.length > 1 ? <MultiOrganizationList organizations={organizations} /> : null}
          </ContentContainer>
        </React.Fragment>
      </PageContainer>
    );
  }
}

export default AppSubscriptions;



// WEBPACK FOOTER //
// ./src/routes/app-dashboards/index.js